export const hamburgerNavTemplate = () =>`
<div class="modal hamburger-nav drop-down-menu closed" id="hamburger" closedby="any">
    <div class="modal-head">
        <div class="modal-left-mobile hidden-dt">
            <img class="gong-logo" width="88" src="https://m.netinfo.bg/gong/images/content/g25/logo/gong_logo_classic.svg" />
            <div class="back-button">
                <svg class="icon arrow-left"><use xlink:href="#icon-arrow_right"></use></svg>
                <span>назад</span>
            </div>
        </div>
        <div class="close-button">
            <svg class="icon close"><use xlink:href="#icon-x"></use></svg>
        </div>
        <form class="search-wrap" action="/search" method="get">
            <input name="q" class="search-input" type="text" placeholder="Търси играч, отбор, първенство">
            <input class="search-btn" type="submit" value="" >
            <svg class="icon search"><use xlink:href="#icon-search"></use></svg>
        </form>
    </div>
    <div class="modal-body">        
        <div class="ham-grid">
            <nav class="ham-sports-nav">
            </nav>
            <div class="promoted-sections">
                <a class="area-1 vgong" href="/vgong" >
                    <h2>Vgong</h2>
                    <p>Спортът в движение</p>
                </a>
                <a class="area-2 livescore" href="/livescore" >
                    <h2>livescore</h2>
                    <p>Спортът в цифри</p>
                </a>
                <a class="area-3 tv-programa" href="/tv" >
                    <h2>тв програма</h2>
                    <p>Спортът на малкия екран</p>
                </a>
                <a class="area-4 games" href="/games" >
                    <h2>Games</h2>
                    <p>Опитай и ти</p>
                </a>
            </div>
            <footer class="footer">
                <nav class="apps">
                    <a href="https://play.google.com/store/apps/details?id=bg.gong" class="gtm-Footer app-Android" data-pos="desktop &gt; line1 &gt; Android" target="_blank">
                        <img class="icon" src="https://m.netinfo.bg/gong/images/content/g25/hamburger/google-play.svg" /><span>Google Play</span></svg>
                    </a>
                    <a href="https://apps.apple.com/us/app/gong-bg/id1013183852" class="gtm-Footer app-iOS" data-pos="desktop &gt; line1 &gt; iOS" target="_blank">
                        <img class="icon" src="https://m.netinfo.bg/gong/images/content/g25/hamburger/app-store.svg" /><span>App Store</span></svg>
                    </a>
                    <a href="https://appgallery.cloud.huawei.com/marketshare/app/C102213081" class="gtm-Footer app-Huawei" data-pos="desktop &gt; line1 &gt; Huawei" target="_blank">
                        <img class="icon" src="https://m.netinfo.bg/gong/images/content/g25/hamburger/app-gallery.svg" /><span>App Gallery</span></svg>
                    </a>
                </nav>
                <nav class="profiles">
                    <a class="gtm-Footer" data-pos="desktop &gt; line1 &gt; Vbox7" href="https://www.vbox7.com/user:gong" target="_blank" title="" rel="noopener">
                        <svg class="icon vbox"><use xlink:href="#icon-vbox"></use></svg>
                        <span>Vbox7</span>
                    </a>
                    <a class="gtm-Footer" data-pos="desktop &gt; line1 &gt; Facebook" href="https://www.facebook.com/gong.bg" target="_blank" title="" rel="noopener">
                        <svg class="icon facebook"><use xlink:href="#icon-facebook"></use></svg>
                        <span>Facebook</span>
                    </a>
                    <a class="gtm-Footer" data-pos="desktop &gt; line1 &gt; Instagram" href="https://www.instagram.com/gongbg/" target="_blank" title="" rel="noopener">
                        <svg class="icon instagram"><use xlink:href="#icon-instagram"></use></svg>
                        <span>Instagram</span>
                    </a>
                    <a class="gtm-Footer" data-pos="desktop &gt; line1 &gt; TikTok" href="https://www.tiktok.com/@gong_bg" target="_blank" title="" rel="noopener">
                        <svg class="icon tiktok"><use xlink:href="#icon-tiktok"></use></svg>
                        <span>Tik Tok</span>
                    </a>
                    <a class="gtm-Footer" data-pos="desktop &gt; line1 &gt; Youtube" href="https://www.youtube.com/@Gong_bg" target="_blank" title="" rel="noopener">
                        <svg class="icon youtube"><use xlink:href="#icon-youtube"></use></svg>
                        <span>YouTube</span>
                    </a>
                    <a class="gtm-Footer" data-pos="desktop &gt; line1 &gt; Twitter" href="https://twitter.com/gong_bg" target="_blank" title="" rel="noopener">
                        <svg class="icon x-twitter"><use xlink:href="#icon-x-twitter"></use></svg>
                        <span>X (Twitter)</span>
                    </a>
                </nav>
                <nav class="about">
                    <a class="gtm-footer" data-pos=""  href="https://www.netinfocompany.bg/" target="_blank" rel="noopener" title="">За нас</a>
                    <a class="gtm-footer" data-pos=""  href="https://www.netinfocompany.bg/media-kit/gongbg-1585" target="_blank" rel="noopener" title="">Реклама</a>
                    <a class="gtm-footer" data-pos=""  href="https://gong.bg/terms" target="_blank" rel="noopener" title="">Общи условия</a>
                    <a class="gtm-footer" data-pos=""  href="https://www.netinfocompany.bg/gdpr/" target="_blank" rel="noopener" title="">Поверителност</a>
                    <a class="gtm-footer" data-pos=""  href="https://www.netinfocompany.bg/contacts/?s=gong" target="_blank" rel="noopener" title="">Контакти</a>
                    <a class="gtm-footer" data-pos=""  href="https://www.netinfocompany.bg/gdpr/" target="_blank" rel="noopener" title="">Политика Лични Данни</a>
                    <a class="trigger-onesignal" href="javascript:;" rel="noopener" title="">Известия</a>
                    <a class="gtm-footer" data-pos=""  href="/author/platena-publikaciia-617" target="_blank" rel="noopener" title="">Платени публикации</a>
                </nav>
                <a target="_blank" href="https://unitedmedia.net/" class="um-logo">
                    <img src="https://gong.bg/resources/images/UN-logo-white-red.svg" alt="United Media" width="56" height="62" />
                </a>
                <nav class="portfolio">
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; CarMarket.bg" href="https://carmarket.bg/" target="_blank" title="CarMarket.bg" rel="noopener">CarMarket.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Dariknews.bg" href="https://dariknews.bg" target="_blank" title="Новини" rel="noopener">Dariknews.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Pariteni.bg" href="https://www.pariteni.bg/" target="_blank" title="Финансови новини" rel="noopener">Pariteni.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Abv.bg" href="https://www.abv.bg/" target="_blank" title="АБВ Поща" rel="noopener">Abv.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Vbox7.com" href="https://www.vbox7.com/" target="_blank" title="Видео" rel="noopener">Vbox7.com</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Sinoptik.bg" href="https://www.sinoptik.bg/" target="_blank" title="Времето" rel="noopener">Sinoptik.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Edna.bg" href="https://www.edna.bg/" target="_blank" title="За жените" rel="noopener">Edna.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; DogsAndCats.bg" href="https://dogsandcats.bg/" target="_blank" title="DogsAndCats.bg" rel="noopener">DogsAndCats.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Ohnamama.bg" href="https://www.ohnamama.bg/" target="_blank" title="Ох, на мама" rel="noopener">Ohnamama.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Grabo.bg" href="https://grabo.bg/" target="_blank" title="grabo" rel="noopener">Grabo.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Опознай.bg" href="https://opoznai.bg/" target="_blank" title="опознай.bg" rel="noopener">Опознай.bg</a>
                    <a class="gtm-footer" data-pos="desktop &gt; line4 &gt; Telegraph.bg" href="https://telegraph.bg/" target="_blank" title="Telegraph.bg" rel="noopener">Telegraph.bg</a>
                    <div class="trade-mark">© 2007-2025 Gong.bg</div>
                </nav>
            </footer>
        </div>
    </div>
</div>
<div class="hamburger-backdrop"></div>
`